<template>
  <v-timeline align-top dense>
    <v-timeline-item
      icon="mdi-calendar"
      color="#001427"
      fill-dot
      v-for="(sc, i) in schedules"
      :key="i"
    >
      <v-card color="#F0807F" dark>
        <v-toolbar dense color="#F0807F" flat>{{ sc.date }}</v-toolbar>
        <v-card-text class="white text--primary">
          <p>{{ sc.text }}</p>
        </v-card-text>
      </v-card>
    </v-timeline-item>
  </v-timeline>
</template>
<script>
export default {
  data() {
    return {
      schedules: [
        {
          date: "20-11-2020",
          text: "Depart To Jakarta"
        },
        {
          date: "21-11-2020",
          text: "Arrived at Jakarta"
        },
        {
          date: "22-11-2020",
          text: "Depart Abu Dabi"
        },
        {
          date: "23-11-2020",
          text: "Depart to Tel-Aviv"
        }
      ]
    };
  }
};
</script>
